import React from 'react'
import { useNavigate } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

interface ButtonProps {
    label?: string,
    color: string,
    icon?: React.ReactElement,
    classProps?: string,
    path?: string,
    responsive?: boolean,
    onClick?: () => void,
    labelStyle?: string
    [key: string]: any
}

const Button: React.FC<ButtonProps> = ({ label='', labelStyle='', icon, color, classProps, path, responsive, onClick, ...props }) => {
  const navigate = useNavigate()
  // Classes de estilo padrão para o botão
  const ButtonStyle = 'duration-200 p-2 border font-medium rounded-md cursor-pointer'

  // Classes de posicionamento padrão para o botão
  const ButtonPositionStyle = `flex items-center ${label ? 'justify-start' : 'justify-center'} gap-1`

  // Objeto para lidar com a escolha da paleta de cores do botão
  const Colors: any = {
    primario: 'border-primario-700 text-primario-700 fill-primario-700 hover:bg-primario-700',
    neutro: 'border-neutro-700 text-neutro-700 fill-neutro-700 hover:bg-neutro-700',
    sucesso: 'border-sucesso-700 text-sucesso-700 fill-sucesso-700 hover:bg-sucesso-700',
    erro: 'border-erro-700 text-erro-700 fill-erro-700 hover:bg-erro-700',
    alerta: 'border-alerta-700 text-alerta-700 fill-alerta-700 hover:bg-alerta-700',
  }

  // Estilos concatenados do botão
  const handleDisabledStyle = () => { return props.disabled ? 'opacity-50 cursor-not-allowed' : '' }
  const ButtonFinalStyle = twMerge(ButtonStyle, ButtonPositionStyle, Colors[color], classProps, 'hover:text-contraste-100 hover:fill-contraste-100', handleDisabledStyle())

  const navigateToPath = () => {
    return path ? navigate(path) : ''
  }

  const handleClick = () => {
    if (onClick) onClick();
    if (path) navigateToPath();
  }

  return (
    <button className={ButtonFinalStyle} onClick={handleClick} {...props} >
        <span>{icon}</span>
        { !responsive && <p className={labelStyle}>{label}</p> }
    </button>
  )
}

export default Button;